import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { CONTACT } from "@/data/content";
import { EASE } from "./Reveal";

export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35zM12.04 21.5h-.01a9.45 9.45 0 0 1-4.82-1.32l-.35-.21-3.58.94.96-3.49-.23-.36a9.43 9.43 0 0 1-1.45-5.03c0-5.22 4.25-9.47 9.48-9.47 2.53 0 4.91.99 6.7 2.78a9.41 9.41 0 0 1 2.77 6.7c0 5.22-4.25 9.46-9.47 9.46zm8.06-17.53A11.33 11.33 0 0 0 12.04.63C5.76.63.65 5.74.65 12.02c0 2.01.52 3.97 1.52 5.7L.55 23.63l6.05-1.59a11.36 11.36 0 0 0 5.44 1.39h.01c6.28 0 11.39-5.11 11.39-11.39 0-3.04-1.18-5.9-3.34-8.06z" />
  </svg>
);

export const WhatsAppButton = () => createPortal(
  <motion.a
    href={CONTACT.whatsappHref}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat on WhatsApp"
    className="group fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-[55] flex items-center gap-3 bg-[#B8874A] text-white border border-[#B8874A] pl-4 pr-4 sm:pr-5 py-3.5 shadow-[0_12px_40px_-12px_rgba(15,35,31,0.6)] hover:bg-[#16302B] hover:border-white/30 transition-colors duration-500"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 2, duration: 0.8, ease: EASE }}
    data-testid="whatsapp-float-button"
  >
    <WhatsAppIcon className="h-5 w-5 text-white" />
    <span className="hidden sm:inline text-[13px] tracking-wide">WhatsApp</span>
  </motion.a>,
  document.body
);
